import React from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import { IC_USER } from '../../Assets/images';
import VerificationStatus from '../VerificationStatus/VerificationStatus';
import { dataLayerAddFamilyMemberinitiation } from '@common/Utility/analytics-utils';
import { changePatientInBooking } from '../BookAppointment/BookingFunnelAnalytics';
import { MY_ASTER_CATEGORY } from '@common/Constants/analytics';

const ProfilesList = ({
  patientProfileData,
  setShowProfilesList,
  setCheckSlotAvailabilityFlag,
  setSelectedProfileData,
  setAppointmentAlreadyBooked,
  setAlreadyBookedAppointmentId,
  setConsultationRestrictionMessage,
  patientId,
  setIsReferral,
  checkIcon,
  setSelectedSlot,
  getPatientDetails,
  setPayType,
  setIsCoverageCalled,
  setIsDefaultInsuranceCovered,
  invokeSessionStorage,
  setShowAddMemberView,
  setShowExistingProfileView,
  areThereExistingProfiles,
  isAddNewFamilyMemberHidden = false,
  screenName ='',
  pageType= '',
  doctorId='',
  referrerPage=''
}) => {

  return (
  <>
    <div className="defaultMessage">Please select from the eligible profiles</div>
    <div className="selectProfileList">
      <div className="d-flex justify-content-between mt-3">
        <div className="bold-text">
          {patientProfileData?.length} Member
          {`${patientProfileData?.length > 1 ? '(s)' : ''}`}
        </div>
        <div
          className={`blue-text ${isAddNewFamilyMemberHidden ? 'hidden' : ''}`}
          onClick={() => {
            if (!isAddNewFamilyMemberHidden) {
              if (areThereExistingProfiles) {
                dataLayerAddFamilyMemberinitiation(
                  screenName,
                  pageType,
                  MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
                  referrerPage,
                  doctorId ? doctorId : '',
                );
                setShowExistingProfileView(true);
                setCheckSlotAvailabilityFlag(true);
              } else {
                dataLayerAddFamilyMemberinitiation(
                  screenName,
                  pageType,
                  MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
                  referrerPage,
                  doctorId ? doctorId : '',
                );
                setShowAddMemberView(true);
                setCheckSlotAvailabilityFlag(true);
              }
            }
          }}
        >
          + Add Member
        </div>
      </div>
      {patientProfileData?.map((patientProfile) => (
        <div
          key={patientProfile.id}
          className={`profileItem ${patientProfile.id === patientId ? 'selected' : ''} cursor-pointer`}
          onClick={() => {
            setSelectedProfileData(patientProfile);
            invokeSessionStorage();
            setShowProfilesList(false);
            setCheckSlotAvailabilityFlag(true);
            setAppointmentAlreadyBooked(false);
            setAlreadyBookedAppointmentId(null);
            setConsultationRestrictionMessage(null);
            setIsReferral(false);
            setSelectedSlot(null);
            setIsCoverageCalled(false);
            setIsDefaultInsuranceCovered(null);
            setPayType('Self-Pay');
            getPatientDetails(patientProfile.id);
            changePatientInBooking(screenName, pageType);
          }}
        >
          {!patientProfile?.nameInitials ? (
            <div className="profileImage">
              <Image
                src={
                  patientProfile.profilePic && patientProfile.profilePic !== null ? patientProfile.profilePic : IC_USER
                }
                width="49"
                height="49"
                alt={patientProfile.name}
              />
            </div>
          ) : (
            <div className="avtarName">{patientProfile?.nameInitials}</div>
          )}

          <div>
            <div className="profileName">{patientProfile?.name}</div>
            {patientProfile?.primaryAcc && <div className="profileRelation">Primary Account</div>}
            <div className="profileRelation">{patientProfile?.relationship}</div>
            <VerificationStatus label={patientProfile?.status} status={patientProfile?.status} />
          </div>
          <div className="checkIcon">
            <Image src={checkIcon} height={28} width={28} alt="icon" />
          </div>
        </div>
      ))}
    </div>
  </>
  )
};

ProfilesList.propTypes = {
  patientProfileData: PropTypes.array.isRequired,
  setShowProfilesList: PropTypes.func.isRequired,
  setCheckSlotAvailabilityFlag: PropTypes.func.isRequired,
  setSelectedProfileData: PropTypes.func.isRequired,
  setAppointmentAlreadyBooked: PropTypes.func.isRequired,
  setAlreadyBookedAppointmentId: PropTypes.func.isRequired,
  setConsultationRestrictionMessage: PropTypes.func.isRequired,
  patientId: PropTypes.string.isRequired,
  setIsReferral: PropTypes.func.isRequired,
  checkIcon: PropTypes.string.isRequired,
  setSelectedSlot: PropTypes.func.isRequired,
  getPatientDetails: PropTypes.func.isRequired,
  setPayType: PropTypes.func.isRequired,
  setIsCoverageCalled: PropTypes.func.isRequired,
  setIsDefaultInsuranceCovered: PropTypes.func.isRequired,
  invokeSessionStorage: PropTypes.func.isRequired,
  setShowAddMemberView: PropTypes.func.isRequired,
  setShowExistingProfileView: PropTypes.func.isRequired,
  areThereExistingProfiles: PropTypes.bool.isRequired,
  isAddNewFamilyMemberHidden: PropTypes.bool.isRequired,
  screenName: PropTypes.string,
  pageType: PropTypes.string,
};

export default ProfilesList;
